<template>
    <b-container class="p-0">
      <b-row class="text-center">
        <b-col>
          <label class="form-group" style="margin-bottom: 7px" v-text="fieldConfig.fieldLabel"></label>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <image-viewer
              class="mb-1 img-fluid"
              v-if="validatedField.value"
              :min-height="100"
              :max-height="195"
              :max-width="200"
              :src="validatedField.value.url"
              :enable-zoom-in="true"
              :zoom="true"
              :remove="true"
              :edit="true"
              @removeImage="setImageAsNull"
              @editImage="editImage"
              @zoomImage="imageZoom"
              :read-only-inputs="readOnly"
          >
          </image-viewer>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="form-group">
          <FileUpload
              data-test-path="form-file-upload"
              @file-selected="imageUploadSelected"
              ref="avatarUpload"
              :read-only="readOnly"
          />
        </b-col>
      </b-row>
      <b-row v-if="!validatedField.isValid">
        <b-col>
          <small style="margin-top: 2px; margin-left: 10px;"
                 class="form-text text-danger font-weight-bold">{{validatedField.errorMessage || '&nbsp;' }}
          </small>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>

import FileUpload from "@/components/FileUpload";
import FormValidatedField from "@/components/forms/FormValidatedField";
import TextListFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextListFormFieldConfig";
import ActivityManager from "@/activity/ActivityManager";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import ImageViewer from "@/components/img/ImageViewer";
import ImageFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/ImageFormFieldConfig";
const PinturaImageEditor = () => require("@/components/img/PinturaImageEditor");
const SlideShow = () => require("@/components/img/SlideShow");

export default {
  name: "ImageRenderer",
  components: {ImageViewer, FileUpload},
  mounted(){
  },
  props:{
    validatedField: { type: FormValidatedField, required:true },
    fieldConfig: { type: ImageFormFieldConfig, required:true },
  },

  methods:{
    setReadOnly(readOnly){
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },
    setEditorMode(val){
      this.editorMode = val;
    },

    setImageAsNull(){
      this.validatedField.value = null;
    },
    async imageZoom() {
      let slideShow = await ActivityManager.showActivity(SlideShow, {
        image: this.validatedField.value,
        singleImageEditor: true,
        uploadImage: async (image) => await Rpc.BusinessEntities.uploadImage(image).lock()
      });
      slideShow.$on("new-image", (image) => {
        this.validatedField.value = image;
      });
    },

    async imageUploadSelected() {
      let avatarUpload = this.$refs.avatarUpload;
      let file = avatarUpload.getFile();
      avatarUpload.setProgress(0);
      try {
        this.validatedField.value = await Rpc.BusinessEntities.uploadImage(file, "").lock().onProgress((e) => {
          avatarUpload.setProgress(e.percent);
        });
        avatarUpload.reset();
      } catch (e) {
        if (e instanceof RpcInputValidationException) {
          avatarUpload.setError(e.fields.image.errorMessage);
        }
      }
    },

    async editImage() {
      let result = await (await ActivityManager.showActivity(PinturaImageEditor, {
        image: this.validatedField.value,
        singleImageEditor: true,
        uploadImage: async (image) => await Rpc.BusinessEntities.uploadImage(image, "").lock()
      })).getResult();

      if (result) {
        this.validatedField.value = result.newFile;
      }
    },

  },

  data: () => ({
    readOnly: true,
    editorMode: false,
  })
}
</script>

<style scoped>

</style>